<template lang="html">

    <section class="ficha-wrapper">

        <template v-if="!!!full | !isPC">
            <nav class="ficha-section row-start" :style="ownstyles.nav">
                <a @click="actual = ['informacion-puesto']" class="section-nav-el"
                    :active="actual.some(e => e == 'informacion-puesto')">{{$t('informacion_puesto')}}</a>
                <a @click="actual = ['datos-generales']" class="section-nav-el"
                    :active="actual.some(e => e == 'datos-generales')">{{$t('datos_generales')}}</a>
                <a @click="actual = ['empresa']" class="section-nav-el"
                    :active="actual.some(e => e == 'empresa')">{{$t('empresa')}}</a>
                    <a @click="actual = ['titulaciones']" class="section-nav-el"
                    :active="actual.some(e => e == 'titulaciones')">{{(brand.nombreTitulaciones) ? brand.nombreTitulaciones[lang] : $t('titulaciones')}}</a>
            </nav>
        </template>

        <template v-else>
            <nav class="ficha-section row-start" :style="ownstyles.nav">
                <a @click="toggleFicha('informacion-puesto')" class="section-nav-el"
                    :active="actual.some(e => e == 'informacion-puesto')">{{$t('informacion_puesto')}}</a>
                <a @click="toggleFicha('datos-generales')" class="section-nav-el"
                    :active="actual.some(e => e == 'datos-generales')">{{$t('datos_generales')}}</a>
                <a @click="toggleFicha('empresa')" class="section-nav-el"
                    :active="actual.some(e => e == 'empresa')">{{$t('empresa')}}</a>
                    <a @click="toggleFicha('titulaciones')" class="section-nav-el"
                    :active="actual.some(e => e == 'titulaciones')">{{(brand.nombreTitulaciones) ? brand.nombreTitulaciones[lang] : $t('titulaciones')}}</a>
            </nav>
        </template>

        <div class="scroll-container" :full="full" v-if="!!data">

            <template v-if="actual.some(e => e == 'informacion-puesto')">
                <ficha-informacion-puesto :data="data.oferta"></ficha-informacion-puesto>
            </template>

            <template v-if="actual.some(e => e == 'datos-generales')">
                <ficha-datos-generales :data="data.oferta"></ficha-datos-generales>
            </template>

            <template v-if="actual.some(e => e == 'empresa')">
                <ficha-empresa :data="data.empresa" :contactos="data.contactosOferta"></ficha-empresa>
            </template>

            <template v-if="actual.some(e => e == 'titulaciones')">
                <ficha-titulaciones @requestFicha="setPractica" :idOFerta="data.oferta.idOferta" :data="data.titulaciones"></ficha-titulaciones>
            </template>



        </div>

        <loading v-else></loading>


        <p class="version" :style="styles.colorBasic">{{version}}</p>

    </section>

</template>

<script lang="js">

    import { mapGetters, mapActions } from 'vuex';

    import onlyArrow from '@/components/parts/icons/only-arrow';
    import arrowlink from '@/components/parts/icons/arrow-link';


    import fichaEmpresa from '@/components/views/ficha-empresa';
    import fichaDatosGenerales from '@/components/views/aprobaciones/ficha-datos-generales';
    import fichaInformacionPuesto from '@/components/views/aprobaciones/ficha-informacion-puesto';
    import fichaTitulaciones from '@/components/views/aprobaciones/ficha-titulaciones';

    import popupObservaciones from '@/components/parts/popup-observaciones';

    import loading from '@/components/parts/loading';


    export default {
        name: 'ficha-wrapper',
        props: ['full'],
        mounted() {
            this.setActual();
            this.setPractica();
            window.sessionStorage.removeItem('idPractica');
        },
        data() {
            return {
                actual: [],
                data: '',
                infoproceso: '',
                popup: {
                    show: false,
                    action: ''
                },
                evaluada : false
            }
        },
        computed: {
            ...mapGetters({
                styles: 'getStyles',
                colors: 'basicColors',
                mensajeEvaluar: 'getmensajeAntesEvaluar',
                version: 'getVersion',
                brand: 'getBrand',
                lang : 'getLanguage'
            }),
            actualLink: function () {
                return `${this.$route.meta.indexPath[this.lang]}/${this.$route.params.status}/${this.$route.params.id}`;
            },
            ownstyles: function () {
                return {
                    nav: {
                        background: this.colors.white,
                        color: this.colors.basic
                    }
                }
            },
            showBotonAccionesEvaluadas: function () {
                let show = false;
                if (!!this.data) {
                    show = (this.data.practica.evaluadaPorTutor != null) ? true : false;
                }
                return show;
            },
            showBotonAccionesValidaciones: function () {
                let show = false;
                if (!!this.data) {
                    show = (this.data.practica.puedeCambiarEstado);
                }
                return show;
            },
            isPC: function () {
                return (window.innerWidth >= 1023);
            }
        },
        methods: {
            ...mapActions(['setMenu', 'requestAprobacion', 'marcarEvaluada', 'marcarEvaluacionPendiente']),
            setActual: function () {
                this.actual = (!!this.$route.params.section) ? [this.$route.params.section] : ['informacion-puesto'];
                if (this.$route.name == 'ficha') {
                    this.setFichas();
                }
            },
            toggleFicha: function (el) {
                if (this.actual.some(e => e == el)) {
                    this.actual = this.actual.filter(e => e != el)
                } else {
                    this.actual.push(el);
                }

                if (this.actual.length >= 3) {
                    this.setMenu(false);
                }
            },
            setFichas: function () {

                let fichas = ['informacion-puesto', 'datos-generales', 'empresa','titulaciones'];

                if (this.isPC) {
                    let cuantas = Math.floor(($(window).width() - 240) / 450);
                    this.actual = fichas.slice(0, cuantas);
                } else {
                    this.actual = ['informacion-puesto'];
                }
            },
            setPractica: function () {

                let id = this.$route.params.id;
                let status = ["pendents","validades","rebutjades","pendientes","validadas","rechazadas", "no_tutorados"];
                
                if (!!!id && Number(this.$route.params.status) > 0 | !status.some(e => e == this.$route.params.status)) {
                    id = this.$route.params.status;
                }

                this.requestAprobacion(id).then(r => {
                    this.data = r;
                });
            },


        },
        components: {
            'only-arrow': onlyArrow,
            'arrow-link': arrowlink,
            'ficha-datos-generales': fichaDatosGenerales,
            'ficha-informacion-puesto': fichaInformacionPuesto,
            'ficha-titulaciones': fichaTitulaciones,
            'ficha-empresa': fichaEmpresa,
            'popup-observaciones': popupObservaciones,
            'loading': loading
        },
        watch: {
            '$route': function () {
                this.data = '';
                this.setActual();
                this.setPractica();
            },
            'full': function () {
                if (this.full) {
                    this.setFichas();
                } else {
                    this.actual = ['estudiante'];
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .ficha-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        padding-bottom: 0px;
        padding-top: 45px;

        &[showBotones="true"] {
            padding-bottom: 60px;
        }
    }

    .ficha-section {
        width: 100%;
        padding: 20px 10px 0 10px;
        position: absolute;
        left: 0;
        top: 0;
        -webkit-flex-wrap: nowrap;
        -moz-flex-wrap: nowrap;
        -ms-flex-wrap: nowrap;
        -o-flex-wrap: nowrap;
        flex-wrap: nowrap;

        a {
            text-transform: uppercase;
            font-weight: 300;
            font-size: 10px;
            height: 25px;
            line-height: 25px;
            padding: 0 5px;
            color: currentColor;
            border-bottom: 1px solid currentColor;
            width: 100%;
        }

        a.router-link-exact-active,
        a[active=true] {
            font-weight: 600;
            position: relative;

            &::before {
                height: 3px;
                width: 100%;
                background: currentColor;
                display: inline-block;
                content: '';
                position: absolute;
                left: 0;
                bottom: 0;
            }
        }
    }



    .contenedor-botones {
        width: 100%;
        position: absolute;
        bottom: 0;
        right: 0;
        padding: 20px;
        padding-bottom: 10px;
        height: auto;


        .contenedor {
            position: relative;
            max-width: 500px;
            display: inline-block;
            width: 100%;
        }

        a {
            margin: 0 15px;
            margin-bottom: 0;
        }

        .next {
            font-size: 12px;
            position: absolute;
            right: 0;
            top: 50%;
            margin: 0;
            margin-top: -22px;
            height: 40px;
            width: 40px;
            line-height: 40px;

            svg {
                height: 25px;
                width: 25px;
            }
        }

        .prev {
            position: absolute;
            left: 0;
            top: 50%;
            margin: 0;
            margin-top: -19px;
            transform: rotate(-180deg);
            height: 40px;
            width: 40px;
            line-height: 40px;

            svg {
                height: 25px;
                width: 25px;
            }
        }
    }

    .scroll-container {
        width: 100%;
        height: 100%;
        min-height: 100%;
        overflow: scroll;
        display: inline-block;
        padding: 10px;
        max-height: calc(100vh - 175px);
    }



    .version {
        position: absolute;
        right: 0;
        bottom: 0;
        left: auto;
        pointer-events: none;
    }

    @media screen and (max-width: 1400px) {
        .scroll-container {
            max-height: calc(100vh - 199px);
        }

        .ficha-wrapper {
            &[showBotones="true"] {
                padding-bottom: 41px;
            }
        }

        .contenedor-botones {
            padding: 10px;
            padding-bottom: 0;
        }
    }

    @media screen and (max-width: 600px) {

        .ficha-wrapper {
            padding-top: 32px;

            &[showBotones="true"] {
                padding-bottom: 41px;
            }
        }

        .scroll-container {
            max-height: calc(100vh - 208px);
        }

        .contenedor-popup .popup {
            padding: 20px;
        }
    }

    @media screen and (max-width: 430px) {
        .ficha-section {
            padding: 10px 0 0 0;
        }

        .scroll-container {
            padding: 10px 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/views/aprobaciones/contenedor-ficha.vue